import { render } from "./Calenders.vue?vue&type=template&id=41b8a617"
import script from "./Calenders.vue?vue&type=script&lang=js"
export * from "./Calenders.vue?vue&type=script&lang=js"

import "./Calenders.vue?vue&type=style&index=0&id=41b8a617&lang=css"

import exportComponent from "C:\\Users\\jason\\Documents\\Saxton-Widgets\\saxton\\saxton-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__